import React, {FC, useEffect} from "react";
import {clearSnackbar} from "../../Redux/Slices/layout";
import {Alert, Snackbar as MuiSnackbar} from "@mui/material";
import {useAppSelector} from "../../Hooks/useAppSelector";
import {useAppDispatch} from "../../Hooks/useAppDispatch";

export const Snackbar: FC<{}> = () => {
    const snackbar = useAppSelector(state => state.layout.snackbar);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const timeout = setTimeout(() => {
            dispatch(clearSnackbar());
        }, 6000);

        return () => clearTimeout(timeout);
    })

    return (
        <>
            {snackbar && (
                <MuiSnackbar
                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                    open={true}
                    onClose={() => dispatch(clearSnackbar())}
                >
                    <Alert onClose={() => dispatch(clearSnackbar())} severity={snackbar.type} sx={{width: '100%'}}>
                        {snackbar.message}
                    </Alert>
                </MuiSnackbar>
            )}
        </>
    );
}
